import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DateFormatterService } from 'src/app/shared/components/date-picker/date-formatter.service';
import { CaseService } from 'src/app/shared/services/case.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';

@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss']
})
export class ReportDetailsComponent implements OnInit {
  reporttypesList: any;
  NationalityList: any;
  reporterNationalTypeList: any;
  reporterRelationList: any;
  caseobject: any;
  isEdit: boolean = false;
  caseId: any;
  caseDetails: any;
  constructor(private dateformat: DateFormatterService ,public lookupService: LookupService, public sharedService: SharedHttpService, public caseservice: CaseService) { }

  reportDate: any;
  reporterNationalTypeId: any;
  reportNumber: any;
  reporterNationalityId: any;
  reporterNationalId: any;
  reporterName: any;
  reporterMobileNumber: any;
  reporterMobileNumber2: any;
  reporterRelationId: any;
  address: any;
  reportDetails: any;
  reportTypeId: any;
  eCaseId: any;
  @Input() loadDataFP: Observable<any>;
  editedDate: NgbDateStruct;
  today = new Date();
    currentDate:NgbDateStruct;
  ngOnInit(): void {
    // this.reporttypesList = this.lookupService.getLockup('reporttypes');
    let url: any = `api/Lookup/GetLookup?key=reporttypes`;
    this.sharedService.get(url).subscribe(result => {
      this.reporttypesList =result;
    });
    this.NationalityList = this.lookupService.getLockup('nationalities');
    this.reporterNationalTypeList = this.lookupService.getLockup('identitytypes');
    this.reporterRelationList = this.lookupService.getLockup('reporterrelations');
    this.currentDate=this.sharedService.convertDateToNgbDateStruct(this.today);
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
          this.loadData();
      }, 100);

  });
  }

  loadData() {
    this.caseDetails=this.caseservice.case;
    this.isEdit = false;
    if (this.caseservice.case != null) {
      this.eCaseId = this.caseservice.case.eCaseId;
      this.caseId = this.caseservice.case.caseId;
      let url: any = `api/CaseReport/GetCaseReport?eCaseId=${this.eCaseId}`;
      this.sharedService.get(url).subscribe(result => {
        if (result != null) {

          this.reportDate =  result.reportDate;
          this.editedDate = this.sharedService.convertDateToNgbDateStruct(result.reportDate);
                    
          this.reporterNationalityId = result.reporterNationalityId;
          this.reporterNationalTypeId = result.reporterNationalTypeId;
          this.reporterNationalId = result.reporterNationalId;
          this.reportNumber = result.reportNumber;
          this.reporterName = result.reporterName;
          this.reporterMobileNumber = result.reporterMobileNumber;
          this.reporterMobileNumber2 = result.reporterMobileNumber2;
          this.reporterRelationId = result.reporterRelationId;
          this.reportDetails = result.reportDetails;
          this.address = result.address;
          this.reportTypeId = result.reportTypeId;
        }
        });
     
    }

  }
  date:any
 

  SelectedDateChange($event) {
    this.reportDate = this.dateformat.ToGregorian2($event);
  }

  numberOnly(event) {
    var inp = String.fromCharCode(event.keyCode);
    let pattern =/^\d+$/;
    if (pattern.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
editMode(){
 this.isEdit=true;

}
showMode(){
  this.loadData();
 }
    SaveCaseReport() {
        let url = `api/CaseReport/SaveCaseReport`;
        let objectAdded =
        {
            reportDate: this.reportDate,
            reporterNationalTypeId: this.reporterNationalTypeId,
            reportNumber: this.reportNumber,
            reporterNationalityId: this.reporterNationalityId,
            reporterNationalId: this.reporterNationalId,
            reporterName: this.reporterName,
            reporterMobileNumber: this.reporterMobileNumber,
            reporterMobileNumber2: this.reporterMobileNumber2,
            reporterRelationId: this.reporterRelationId,
            address: this.address,
            reportDetails: this.reportDetails,
            reportTypeId: this.reportTypeId,
            eCaseId: this.eCaseId,
            caseId: this.caseId
        };
        this.sharedService.post(url, objectAdded).subscribe((res) => {
            this.isEdit = false;
            this.sharedService.showSuccessKey("EditSuccessfully");
      
          });
    }
}
